/*
 * Fifty Five – Marktvergleich „eine Saeule“. Gehoert zu sections/ff-market-compare.liquid.
 * Nur ein sanftes Einblenden der Zeilen beim Scrollen (IntersectionObserver, Gate .is-armed,
 * ohne JS / reduced motion alles sofort sichtbar). Kein Umschalter, kein Tausch mehr.
 */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (!root || root.dataset.ffmReady === '1') return;
    root.dataset.ffmReady = '1';
    if (reduced || !('IntersectionObserver' in window)) return;
    var rows = root.querySelectorAll('.ffm__row');
    if (!rows.length) return;
    root.classList.add('is-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = Array.prototype.indexOf.call(rows, e.target);
        setTimeout(function () { e.target.classList.add('is-on'); }, Math.min(i, 8) * 60);
        io.unobserve(e.target);
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -5% 0px' });
    Array.prototype.forEach.call(rows, function (r) { io.observe(r); });
  }
  function scan(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ffm]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
